const template = require('./filter_search.html.slim')
declare var angular
import { merge } from 'lodash'

export class FilterSearch {
  static $inject = ['$rootScope', '$location']

  query: string

  private _search: string = null

  constructor(private $rootScope, private $location) {
    this._search = $location.search()[this.query]

    $rootScope.$on('deselectFilterTriggered', (() => {
      this.search = undefined
    }));

    $rootScope.$on('$routeUpdate', (() => {
      this._search = $location.search()[this.query]
    }));
  }

  public showDefault(active) { return (!active && !this.search) }
  public showSelected(active) { return active }
  public showActive(active) { return (!active && this.search) }

  // TODO: Find less hackish way to do this
  public hideInput(): void { angular.element('body').trigger('click') }

  get search(): string { return this._search }
  set search(value) {
    var query: Object = {}
    query[this.query] = value || ''
    this.$location.search(merge(this.$location.search(), query))
    this._search = value
  }
}


angular.module('wbComponents').directive('wbFilterSearch', function() {
  return {
    restrict: 'E',
    controller: FilterSearch,
    controllerAs: 'ctrl',
    bindToController: true,
    scope: {
      query: '@'
    },
    templateUrl: template,
    link: function($scope, element, attrs, ctrl: FilterSearch) {
      element.on('keydown', function(event): void {
        if (event.keyCode === 13) { ctrl.hideInput() }
      })
    }
  }
})
